import React, { useState, useEffect } from "react";
import { resolveMediaUrl } from "../lib/media";

export default function PlayerAvatar({ player, size = 48, className = "" }) {
  const initials = `${(player?.first_name || "").charAt(0)}${(player?.last_name || "").charAt(0)}`.toUpperCase() || "?";
  const style = { width: size, height: size, minWidth: size };
  const src = resolveMediaUrl(player?.photo_url);
  const [broken, setBroken] = useState(false);

  useEffect(() => { setBroken(false); }, [src]);

  if (src && !broken) {
    return (
      <img
        src={src}
        alt={`${player.first_name || ""} ${player.last_name || ""}`.trim()}
        style={style}
        onError={() => setBroken(true)}
        className={`object-cover rounded-md border border-neutral-800 ${className}`}
      />
    );
  }
  return (
    <div
      style={style}
      className={`rounded-md bg-neutral-900 border border-neutral-800 flex items-center justify-center font-display font-bold text-neutral-300 ${className}`}
    >
      <span style={{ fontSize: size * 0.4 }}>{initials}</span>
    </div>
  );
}
